import { Box, Fab, useTheme } from '@mui/material';
import { useRef, useState } from 'react';

import { getBoostBrandConfig } from '@acorn-portal/shared/src/config/boost-ai';
import useBoostAi from '@acorn-portal/shared/src/utils/initialise-boost-ai';
import { SilentCodeForwarder, SilentCodeForwarderRef } from '../../utils/silentCodeForwarder';

const ChatButtonContent = () => {
	const silentCodeForwarderRef = useRef<SilentCodeForwarderRef>(null);
	const [isAuthenticating, setIsAuthenticating] = useState(false);
	const [isAuthenticated, setIsAuthenticated] = useState(false);

	const handleAuthExpired = (isAuthenticated: boolean) => {
		setIsAuthenticated(isAuthenticated);
		silentCodeForwarderRef.current?.reset();
	};

	const theme = useTheme();
	const { handleAuthCallback } = useBoostAi(theme, handleAuthExpired);
	const { avatarUrl } = getBoostBrandConfig(theme);
	const useAuthentication = import.meta.env.VITE_BOOST_AI_USE_AUTH === 'true';

	const openChat = () => {
		if (window.boost && window.boost?.chatPanel) {
			if (useAuthentication && !isAuthenticating && !isAuthenticated) {
				setIsAuthenticating(true);
				silentCodeForwarderRef.current?.startSilentAuth();
			} else {
				window.boost.chatPanel.show();
			}
		}
	};

	const handleAuthError = (error: string) => {
		console.error('Authentication failed:', error);
		setIsAuthenticating(false);
		setIsAuthenticated(false);
		window.boost?.chatPanel?.show();
		silentCodeForwarderRef.current?.reset();
	};

	const handleAuthSuccess = (code: string) => {
		setIsAuthenticating(false);
		setIsAuthenticated(true);
		handleAuthCallback(code);
	};

	return (
		<>
			<SilentCodeForwarder ref={silentCodeForwarderRef} callback={handleAuthSuccess} onError={handleAuthError} />
			<Fab
				sx={{
					position: 'fixed',
					bottom: 16,
					right: 16,
					height: '80px',
					width: '80px',
					display: 'block',
					opacity: isAuthenticating ? 0.7 : 1,
				}}
				aria-label='Chat Button'
				color='primary'
				onClick={openChat}
				size='large'
				disabled={isAuthenticating}
			>
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
					<img src={avatarUrl} alt='Chat Avatar' style={{ height: '60px' }} />
				</Box>
			</Fab>
		</>
	);
};

const ChatButton = () => {
	if (!import.meta.env.VITE_BOOST_AI_TENANT) return null;
	return <ChatButtonContent />;
};

export default ChatButton;
